// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sL4vreGOo1xPbZa7GgLp {
	align-items: center;
	background-color: #ededed;
	border-radius: 6px;
	color: var(--green);
	display: flex;
	font-size: 12px;
	height: 24px;
	letter-spacing: -0.08em;
	line-height: 20px;
	margin-right: 8px;
	max-width: 80px;
	padding: 0 8px;
}
.xDMRhUnRl9es5J6jJxes {
	align-items: center;
	display: flex;
	max-width: 300px;
}
@media (max-width: 767px) {
.xDMRhUnRl9es5J6jJxes {
		max-width: 135px;
}
	}
.Uso9cKGWdRcJEFcpbq60 {
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LockSettingsPage/AboutLockInfoWithChange.pcss"],"names":[],"mappings":"AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;CAClB,mBAAmB;CACnB,aAAa;CACb,eAAe;CACf,YAAY;CACZ,uBAAuB;CACvB,iBAAiB;CACjB,iBAAiB;CACjB,eAAe;CACf,cAAc;AACf;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,gBAAgB;AAKjB;AAHC;AALD;EAME,gBAAgB;AAElB;CADC;AAGD;CACC,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;AACjB","sourcesContent":["@import '../../stylesheets/media-queries.pcss';\n\n.change {\n\talign-items: center;\n\tbackground-color: #ededed;\n\tborder-radius: 6px;\n\tcolor: var(--green);\n\tdisplay: flex;\n\tfont-size: 12px;\n\theight: 24px;\n\tletter-spacing: -0.08em;\n\tline-height: 20px;\n\tmargin-right: 8px;\n\tmax-width: 80px;\n\tpadding: 0 8px;\n}\n\n.content {\n\talign-items: center;\n\tdisplay: flex;\n\tmax-width: 300px;\n\n\t@media (--mobile) {\n\t\tmax-width: 135px;\n\t}\n}\n\n.text {\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\toverflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"change": `sL4vreGOo1xPbZa7GgLp`,
	"content": `xDMRhUnRl9es5J6jJxes`,
	"text": `Uso9cKGWdRcJEFcpbq60`
};
export default ___CSS_LOADER_EXPORT___;
